export const voidbrand = {
  key: 'voidbrand',
  name: 'Voidbrand',
  category: 'curse',
  description: 'A word is erased from the opening breath.',
};
